<template>
  <v-dialog v-model="dialog" class="height-100" :width="checkForm ? 550 : 1300">
    <FirstPage :status="'order'" v-if="checkForm" />
    <v-card v-else>
      <v-card-title class="back">
        <h3 class="color-white">발주양식 업로드</h3>
        <v-spacer />
        <v-icon color="white pointer" @click="dialog = !dialog">
          mdi-close</v-icon
        >
      </v-card-title>
      <v-row class="justify-center ma-0 pa-0">
        <v-simple-table max-height="500" class="ma-3" fixed-header>
          <thead>
            <tr class=" color-white text-center">
              <th
                rowspan="2"
                class="color-white text-center border-right-white back-556C96"
              >
                발주차수
              </th>
              <th rowspan="2" class="color-white text-center back-556C96">
                부위
              </th>
              <th
                :colspan="materialList.length"
                class="color-white text-center border-left-white back-556C96"
              >
                규격(단위:TON)
              </th>
              <th
                rowspan="2"
                class="color-white text-center border-left-white back-556C96 "
              >
                발주수량
              </th>
              <th
                rowspan="2"
                class="color-white text-center border-left-white back-556C96 "
              >
                날짜
              </th>
            </tr>
            <tr>
              <th
                class="back-556C96 color-white text-center border-top-white border-left-white"
                v-for="list in materialList"
                :key="list.rebar_id"
              >
                {{ list.rebar_name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, i) in orderData"
              :key="item.orderName"
              class="text-center"
            >
              <td class="border-left-aaaaaa border-bottom-aaaaaa ">
                {{ item.orderName }}
              </td>
              <td class="border-left-aaaaaa border-bottom-aaaaaa ">
                {{ item.partName }}
              </td>
              <td
                v-for="index in materialList.length"
                :key="index"
                class="border-left-aaaaaa border-bottom-aaaaaa "
              >
                <input
                  v-model.number="tempList[i][index - 1]"
                  class="pa-0 text-center border-aaaaaa width-60"
                  type="number"
                />
              </td>
              <td class="border-left-aaaaaa border-bottom-aaaaaa ">
                {{ sum(tempList[i]) }}
              </td>
              <td
                class="border-left-aaaaaa border-bottom-aaaaaa border-right-aaaaaa"
              >
                {{ item.registeDate }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-row>
      <v-row class="justify-center  ml-0 mr-0 pb-5">
        <v-btn
          color="#3F557D"
          width="183"
          height="53"
          rounded
          class="color-white ml-3"
          @click="insertData"
          >확인
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import FirstPage from "./form/FirstPage.vue";
import OrderApi from "@/api/OrderService";
import XLSX from "xlsx";
import Commonality from "@/mixin/Commonality";

export default {
  components: { FirstPage },
  mixins: [Commonality],
  created() {
    this.$bus.$on("OrderFormOn", () => {
      this.dialog = true;
    });
    this.$bus.$on("OrderFormOff", () => {
      this.dialog = false;
    });
    this.$bus.$on("fileSearch", async (file) => {
      this.file = file;
      await this.excelRead();
    });
  },
  beforeDestroy() {
    this.$bus.$off("OrderFormOn");
    this.$bus.$off("OrderFormOff");
    this.$bus.$off("fileSearch");
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$bus.$emit("fileClear");
        this.checkForm = true;
      }
    },
  },
  computed: {
    header() {
      let list = ["orderName", "partName"];
      for (let i = 0; i < this.materialList.length; i++) {
        list.push(this.materialList[i].rebar_name);
      }
      list.push("totalSum", "registeDate");
      return list;
    },
  },
  data: function() {
    return {
      checkForm: true,
      dialog: false,
      file: "",
      orderData: [],
      tempList: [],
      resetList: [],
    };
  },
  methods: {
    excelRead() {
      let reader = new FileReader();
      this.orderData = [];
      reader.onload = () => {
        let data = reader.result;
        // let data = e.target.result;
        let workbook = XLSX.read(data, {
          type: "binary",
          cellDates: true,
          dateNF: "yyyy-mm-dd",
        });
        workbook.SheetNames.forEach((sheetName) => {
          const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
            header: this.header,
            dateNF: "YYYY-MM-DD",
            raw: false,
          });
          if (
            roa[0].orderName != "철근 발주 입고 일괄 엑셀 발주 양식" &&
            roa[0].orderName != "철근 발주 현황"
          ) {
            this.$bus.$emit(
              "dialog",
              "발주 양식이 아닙니다. 양식 다운로드을 업로드 해주세요."
            );
            return;
          }
          if (roa[1].partName != this.constructionName.constructionName) {
            this.$bus.$emit("dialog", "현재 현장과 다른 현장입니다.");
            return;
          }
          if (!roa[3].orderName) {
            this.$bus.$emit("dialog", "입력후 진행 해주세요.");
            return;
          }
          let startNumber = 0;
          let list = [];
          let tempList = [];
          let resetList = [];
          for (let i = 3; i < roa.length; i++) {
            if (roa[i].orderName) {
              tempList[startNumber] = [];
              resetList[startNumber] = [];
              list[startNumber] = {};
              list[startNumber].constructionId = this.constructionId;
              list[startNumber].orderName = roa[i].orderName;
              list[startNumber].partName = roa[i].partName;
              list[startNumber].registeDate = roa[i].registeDate;
              list[startNumber].rebarList = [];
              for (let j = 0; j < this.materialList.length; j++) {
                tempList[startNumber][j] = this.regexForData(
                  roa[i][this.materialList[j].rebar_name]
                );
                resetList[startNumber][j] = this.regexForData(
                  roa[i][this.materialList[j].rebar_name]
                );
              }
              startNumber++;
            }
            if (i == roa.length - 1) {
              this.orderData = list;
              this.resetList = resetList;
              this.tempList = tempList;
            }
          }
          if (this.orderData.length > 0) this.checkForm = !this.checkForm;
        });
      };
      reader.readAsBinaryString(this.file);
    },
    async insertData() {
      for (let i = 0; i < this.tempList.length; i++) {
        this.orderData[i].rebarList = this.tempList[i];
      }
      let data = { orderData: this.orderData };
      let res = await OrderApi.orderCreate(data);
      if (res.data.success == "ok") {
        this.$bus.$emit("dialog", "발주데이터 입력이 완료되었습니다.");
        this.dialog = false;
      } else this.$bus.$emit("dialog", res.data.reason);
      this.$bus.$emit("orderNavigationDuplicated");
    },
  },
};
</script>

<style scoped>
.width-60 {
  width: 60px;
}
</style>
